
const INSERE_CONCLUSOES = (state, payload) => {
  state.items = payload
}

const LOADING = (state, payload) => {
  state.loading = payload
}

export {
  INSERE_CONCLUSOES,
  LOADING
}